import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import ColumnFilterHeader from '@/widgets/ColumnFilterHeader'
import { getSortIndicator } from '@/lib/tableHelpers'
import GminaTableRow from './GminaTableRow'

export default function GminaTable({
	data,
	loading,
	sortColumn,
	sortDirection,
	onSort,
	hasPowiatFilter,
	hasWojewodztwoFilter,
	onOpenPowiatFilter,
	onOpenWojewodztwoFilter,
	onPowiatFilter,
	onWojewodztwoFilter,
	onNazwaClick,
}) {
	const rows = Array.isArray(data) ? data : []

	if (loading) return <LoadingIndicator />

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<button
								type="button"
								className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('nazwa')}>
								Nazwa
								{getSortIndicator('nazwa', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<ColumnFilterHeader
								label="Powiat"
								hasFilter={hasPowiatFilter}
								onOpenFilter={onOpenPowiatFilter}
								onClearFilter={() => onPowiatFilter(null)}
							/>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<ColumnFilterHeader
								label="Wojewodztwo"
								hasFilter={hasWojewodztwoFilter}
								onOpenFilter={onOpenWojewodztwoFilter}
								onClearFilter={() => onWojewodztwoFilter(null)}
							/>
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map(item => (
						<GminaTableRow
							key={item._id || item.id || item.nazwa}
							gmina={item}
							onPowiatFilter={onPowiatFilter}
							onWojewodztwoFilter={onWojewodztwoFilter}
							onNazwaClick={onNazwaClick}
						/>
					))}
				</tbody>
			</table>
			{rows.length === 0 ? (
				<div className="py-4">
					<NoResultsIndicator
						message="Nie znaleziono gmin"
						description="Sprobuj zmienic wyszukiwanie"
					/>
				</div>
			) : null}
		</div>
	)
}
